export const hasActiveDescendant = (item, pathname) => {
    if (
        item.path &&
        (pathname === item.path || pathname.startsWith(`${item.path}/`))
    ) {
        return true;
    }
    return (item.sub || []).some((sub) => hasActiveDescendant(sub, pathname));
};

export const isMenuItemActive = (item, pathname) => {
    if (
        item.path === '/admin/dashboard' &&
        (pathname === '/admin' || pathname === '/admin/')
    ) {
        return true;
    }
    if (
        item.path &&
        (pathname === item.path || pathname.startsWith(`${item.path}/`))
    ) {
        return true;
    }
    if (item.sub?.length) {
        return item.sub.some((sub) => hasActiveDescendant(sub, pathname));
    }
    return false;
};

export const findActiveParentIndex = (menu, pathname) =>
    menu.findIndex(
        (item) =>
            item.sub?.length > 0 &&
            item.sub.some((sub) => hasActiveDescendant(sub, pathname))
    );
